import styled from '@emotion/styled';

export const KonvaCanvasWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  overflow: auto;
`;
